module.exports = __webpack_public_path__ + "static/media/charts-footer-image1.1c45826a.PNG";